// UploadStock.js
import React, { useState } from "react";
import axios from "axios";

const UploadStock = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage("Primero selecciona un archivo.");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post("http://localhost:5000/api/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage(response.data.message);
    } catch (error) {
      setMessage("Error al cargar el archivo, por favor intentalo de nuevo más tarde.");
    }
  };

  return (
    <div className="p-6">
      <input type="file" accept=".xlsx,.csv" onChange={handleFileChange} />
      <button onClick={handleUpload} className="bg-blue-600 text-white px-4 py-2 rounded mt-4">
        Subir archivo del inventario
      </button>
      {message && <p className="mt-2">{message}</p>}
    </div>
  );
};

export default UploadStock;
